(function() {
  function initSizeChart() {
    var btnCm = document.getElementById('btn-cm');
    var btnInch = document.getElementById('btn-inch');
    var unitCm = document.getElementById('unit-cm');
    var unitInch = document.getElementById('unit-inch');
    var lightbox = document.getElementById('fm-lightbox');
    var lightboxImg = document.getElementById('fm-lightbox-img');

    if (!btnCm || !btnInch) return;

    btnCm.addEventListener('click', function(e) {
      e.preventDefault();
      unitCm.style.display = 'block';
      unitInch.style.display = 'none';
      document.querySelector('.fm-note').innerHTML = 'All measurements in cm. Fit may vary slightly.<br>If you want to compare with one of your tees, lay it flat and use a tape measure.';
      btnCm.classList.add('active'); btnCm.classList.remove('inactive');
      btnInch.classList.add('inactive'); btnInch.classList.remove('active');
      btnCm.style.background = '#222'; btnCm.style.color = '#fff';
      btnInch.style.background = '#eee'; btnInch.style.color = '#222';
    });

    btnInch.addEventListener('click', function(e) {
      e.preventDefault();
      unitInch.style.display = 'block';
      unitCm.style.display = 'none';
      document.querySelector('.fm-note').innerHTML = 'All measurements in inches. Fit may vary slightly.<br>If you want to compare with one of your tees, lay it flat and use a tape measure.';
      btnInch.classList.add('active'); btnInch.classList.remove('inactive');
      btnCm.classList.add('inactive'); btnCm.classList.remove('active');
      btnInch.style.background = '#222'; btnInch.style.color = '#fff';
      btnCm.style.background = '#eee'; btnCm.style.color = '#222';
    });

    document.querySelectorAll('.fm-table-wrap').forEach(function(wrap) {
      var startX, startY, isHorizontal;

      wrap.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isHorizontal = null;
      }, { passive: true });

      wrap.addEventListener('touchmove', function(e) {
        if (isHorizontal === null) {
          var dx = Math.abs(e.touches[0].clientX - startX);
          var dy = Math.abs(e.touches[0].clientY - startY);
          if (dx + dy < 5) return;
          isHorizontal = dx > dy;
        }
        if (isHorizontal) {
          e.stopPropagation();
        }
      }, { passive: true });
    });

    document.querySelectorAll('.fm-zoomable').forEach(function(img) {
      img.addEventListener('click', function() {
        lightboxImg.src = img.src;
        lightbox.classList.add('open');
      });
    });

    if (lightbox) {
      lightbox.addEventListener('click', function() {
        lightbox.classList.remove('open');
        lightboxImg.src = '';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChart);
  } else {
    initSizeChart();
  }
})();
